import { Link } from 'react-router-dom';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

import { getConversationTitle } from '../../helpers';
import { formatLocalDate, formatLocalTime } from '@/helpers/dateHelpers';

import NotificationDot from './NotificationDot';

import { useSelf } from '@/data/user';

const ConversationPreviewRow = ({ conversation }) => {
  const self = useSelf();

  const { title, avatarFallback } = getConversationTitle(
    conversation,
    self.data
  );
  const dateToFormat =
    conversation.lastMessage?.createdAt || conversation.createdAt;
  const displayDate = formatLocalDate(dateToFormat);
  const displayTime = formatLocalTime(dateToFormat);

  return (
    <Link
      to={`/conversation/${conversation.id}`}
      className="block"
      key={conversation.id}
    >
      <li className="p-4 hover:bg-muted cursor-pointer">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <NotificationDot conversationId={conversation.id} />
            <Avatar className="relative">
              <AvatarImage
                src="/placeholder.svg?height=40&width=40"
                alt="John Doe"
              />
              <AvatarFallback>{avatarFallback}</AvatarFallback>
            </Avatar>
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium truncate">{title}</p>
            <p className="text-sm text-muted-foreground truncate">
              {conversation.lastMessage?.content || 'No messages yet'}
            </p>
          </div>
          <div className="flex flex-col items-end text-xs text-muted-foreground">
            <div>{displayDate}</div>
            <div>{displayTime}</div>
          </div>
        </div>
      </li>
    </Link>
  );
};

export default ConversationPreviewRow;
